var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.Loading)?_c('div',{staticClass:"loading-box"},[_c('van-loading',{attrs:{"color":_vm.color,"size":"24px","vertical":""}},[_vm._v(_vm._s(_vm.tips))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }